// var clientID = "osQFCwgd";
// var clientSecret = "PgaiDPDJQZ8CXpr";
// var testAttemptId = CryptoJS.lib.WordArray.random(5).toString();
// var hashedTestAttemptId = CryptoJS.SHA256(testAttemptId + clientSecret).toString();
 
//  const credentials = {
//     clientId: clientID,
//     testAttemptId: testAttemptId,
//     hashedTestAttemptId: hashedTestAttemptId
//   };
// const autoProctorTest = new AutoProctor(credentials);
/*
 * testAttemptId identifies each test attempt. This is a unique ID that your own platform generates
 */
 
// var testAttemptId = CryptoJS.lib.WordArray.random(5).toString();
 
/*
 * The SHA-256 HMAC of the testAttemptId with your SECRET_KEY
 * For more info: https://www.autoproctor.co/developers/docs#authentication
 */
// var hashedTestAttemptId = CryptoJS.SHA256(testAttemptId + clientSecret).toString();
 
//Configurations which you have to pass in SDK
// alert('calling js ')
var autoProctorTest = null;
var AutoProctor = null;
 
async function getReport(clientID, clientSecret, testAttemptId, hashedTestAttemptId) {
  const credentials = {
    clientId: clientID,
    testAttemptId: testAttemptId,
    hashedTestAttemptId: hashedTestAttemptId
  };
  var apSettings = {
    trackingOptions: {
      audio: true,
      numHumans: true,
      tabSwitch: true,
      captureSwitchedTab: true,
      photosAtRandom: true,
      detectMultipleScreens: true,
      forceFullScreen: false,
      testTakerPhoto: true,
      numPhotosAtRandom: 10,
    },
    showHowToVideo: false,
  };
  autoProctorTest = new AutoProctor(credentials);
  await autoProctorTest.setup(apSettings);
  const reportOptions = getReportOptions();
  autoProctorTest.showReport(reportOptions);
}
 
async function getReportData(clientID, testAttemptId, hashedTestAttemptId) {
  try {
    if (!window.AutoProctor) {
      throw new Error("AutoProctor SDK not loaded");
    }
 
    const credentials = {
      clientId: clientID,
      testAttemptId: testAttemptId,
      hashedTestAttemptId: hashedTestAttemptId
    };
 
    var apSettings = {
      trackingOptions: {
        audio: true,
        numHumans: true,
        tabSwitch: true,
        captureSwitchedTab: true,
        photosAtRandom: true,
        detectMultipleScreens: true,
        forceFullScreen: false,
        testTakerPhoto: true,
        numPhotosAtRandom: 10
      },
      showHowToVideo: false
    };
 
    // Create new instance (same as getReport)
    autoProctorTest = new AutoProctor(credentials);
 
    // Setup SDK
    await autoProctorTest.setup(apSettings);
 
    // Report options (same as your existing function)
    const reportOptions = {
      groupReportsIntoTabs: true,
      userDetails: {
        name: "a@b.com",
        email: "Test@123"
      }
    };
 
    // ✅ Get report data instead of showing UI
    const result = await autoProctorTest.getReport(reportOptions);
 
    return result;
 
  } catch (error) {
    console.error("Failed to get report data:", error);
    return null;
  }
}
 
const getReportOptions = () => {
  return {
    groupReportsIntoTabs: true,
    userDetails: {
      name: "a@b.com",
      email: "Test@123"
    }
  };
};
 
async function inittest(clientID, clientSecret, testAttemptId, hashedTestAttemptId, duration) {
 
  try {
 
    if (!window.AutoProctor) {
      throw new Error("AutoProctor SDK not loaded");
    }
 
    const credentials = {
      clientId: clientID,
      testAttemptId: testAttemptId,
      hashedTestAttemptId: hashedTestAttemptId
    };
 
    autoProctorTest = new window.AutoProctor(credentials);
 
    const apSettings = {
      trackingOptions: {
        audio: true,
        numHumans: true,
        tabSwitch: true,
        captureSwitchedTab: true,
        photosAtRandom: true,
        detectMultipleScreens: true,
        showCamPreview: true,
        testDuration: duration
      }
    };
 
    await autoProctorTest.setup(apSettings);
 
    autoProctorTest.start();
 
    return true;
 
  } catch (error) {
 
    console.error("AutoProctor initialization failed:", error);
 
    return false;
 
  }
 
}
// function startproctor() {
//   autoProctorTest.start();
// }
function Terminateproctor() {
  autoProctorTest.stop();
}
function stopproctor(clientID, testAttemptId, hashedTestAttemptId) {
  autoProctorTest.stop();
  // const label = await fetch('https://www.autoproctor.co/tenant/tests/capture-test-submit');
 
  let testReportUrl = "https://www.autoproctor.co/tenant/" + clientID + "/test-attempts/id/" + testAttemptId + "/?hashedTestAttemptId=" + hashedTestAttemptId;
  return testReportUrl;
  // alert(testReportUrl);
  // const response= await fetch(testReportUrl);    
  // const response =  autoProctorTest.getEvidenceReport(
  //     clientID,
  //     testAttemptId,
  //     hashedTestAttemptId
  // );
  // const searchParams = new URLSearchParams({
  //     "hashedTestAttemptId": hashedTestAttemptId
  //   });
 
  //   let url = "https://www.autoproctor.co/tests/reports/test-attempt-label/" + testAttemptId + "?hide_navbar=true";      
  //   url.search = searchParams;
 
  //   await fetch(url);
  // const response =  autoProctorTest.getEvidenceReport(
  //     apSettings.clientId,
  //     apSettings.testAttemptId,
  //     apSettings.hashedTestAttemptId
  // );
}